/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import * as yup from 'yup';

import TagList2 from 'components/TagList2';
import { Row, Col } from "components/Grid";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import Loader from 'components/Loader';
import Label from "components/Form/Label";
import { LostCancelButton, TextEditorBox } from 'components/index';
import { Icon } from 'components';
import CheckBox from "components/Form/CheckBox";
import _ from 'lodash';

import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { PlaceHolder, TagInput, ButtonContent, Title, RowIcon, RowDocuments, BorderSwitch } from "./styles";
import StepNavigation from "components/StepNavigation/index";
import DragZoneUpload from 'components/DragZoneUpload';
import Switch from 'react-switch';
import { 
  useHeaderNbi, 
  useGetDocumentsEndorsementContracts, 
  useEndorsementPackRiskMarketChangesLastQuestionnaireMrc, 
  useEndorsementPackRiskMarketChangesListPreviewDocuments, 
  useScheduleReport, 
  useStatusScheduleReport 
} from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService';
import { onValidationError } from '../../../../utils/src/validationForm';
import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import {
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswer
} from '@fitinsur/services/QuestionnaireAnswerService';
import {
  useUpdateOperations
} from '@fitinsur/services/OperationService';
import PremiumCalculationSection from "components/PremiumCalculationSection/index";

const SECTIONS = {
  ENDORSEMENT_EDIT: { name: 'ENDORSEMENT_EDIT', isMultiple: false, isRisk: false }
};

export default function GenerateEndorsementPackRiskMarketChanges(props) {

  const [historymsg, setHistorymsg] = useState([]);
  const [summary, setSummary] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [isApproved, setIsApproved] = useState(false);

  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);

  const [initialContractChanges, setInitialContractChanges] = useState("");
  const [lastIdQuestionnaire, setLastIdQuestionnaire] = useState(null);
  const [insurersToGenerateMrc, setInsurersToGenerateMrc] = useState([]);
  const [willGenerateMrcDocument, setWillGenerateMrcDocument] = useState(false);
  const [idProduct, setIdProduct] = useState(null);
  const [idDomainDocument, setIdDomainDocument] = useState(null);
  const [idDomainStatusDocument, setIdDomainStatusDocument] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [idDocumentsToSave, setIdDocumentsToSave] = useState([]);
  const [listPreviewDocuments, setListPreviewDocuments] = useState([]);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [operationMetadata, setOperationMetadata] = useState(null);
  const [isDisable, setIsDisable] = useState(true);
  const [generateSignatureEndorsementsLoading, setGenerateSignatureEndorsementsLoading] = useState(false);

  const formik = useRef(null);
  const history = useHistory();

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const validationSchema = yup.object().shape({});

  const isClient = authContext.enumProfile == 1 ? true : false;

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useGetDocumentsEndorsementContractsData,
    loading: useGetDocumentsEndorsementContractsLoading,
    error: useGetDocumentsEndorsementContractsError,
    status: useGetDocumentsEndorsementContractsStatus,
    request: useGetDocumentsEndorsementContractsRequest,
  } = useGetDocumentsEndorsementContracts(props.match.params.idOperation);

  const {
    data: useEndorsementPackRiskMarketChangesLastQuestionnaireMrcData,
    loading: useEndorsementPackRiskMarketChangesLastQuestionnaireMrcLoading,
    error: useEndorsementPackRiskMarketChangesLastQuestionnaireMrcError,
    status: useEndorsementPackRiskMarketChangesLastQuestionnaireMrcStatus,
    request: useEndorsementPackRiskMarketChangesLastQuestionnaireMrcRequest,
  } = useEndorsementPackRiskMarketChangesLastQuestionnaireMrc(props.match.params.idOperation);

  const {
    data: useEndorsementPackRiskMarketChangesListPreviewDocumentsData,
    loading: useEndorsementPackRiskMarketChangesListPreviewDocumentsLoading,
    error: useEndorsementPackRiskMarketChangesListPreviewDocumentsError,
    status: useEndorsementPackRiskMarketChangesListPreviewDocumentsStatus,
    request: useEndorsementPackRiskMarketChangesListPreviewDocumentsRequest,
  } = useEndorsementPackRiskMarketChangesListPreviewDocuments(props.match.params.idOperation);

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useUpdateOperationsData,
    loading: useUpdateOperationsLoading,
    error: useUpdateOperationsError,
    status: useUpdateOperationsStatus,
    request: useUpdateOperationsRequest,
  } = useUpdateOperations(props.match.params.idOperation);

  const {
    data: useScheduleReportData,
    loading: useScheduleReportLoading,
    error: useScheduleReportError,
    status: useScheduleReportStatus,
    request: useScheduleReportRequest,
  } = useScheduleReport(props.match.params.idOperation);

  const {
    data: useGetScheduleReportStatusData,
    loading: useGetScheduleReportStatusLoading,
    error: useGetScheduleReportStatusError,
    status: useGetScheduleReportStatusStatus,
    request: useGetScheduleReportStatusRequest,
  } = useStatusScheduleReport(props.match.params.idOperation);

  useEffect(() => {
    buildValidation();
    const contractDocuments = questionnaire.find((qst) => qst.idQuestion === 1867)?.answer || [];

    if (contractDocuments.length > 0) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  }, [questionnaire]);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  async function generateScheduleReport() {

    useScheduleReportRequest(null, { finalView: true });

    let documentStatus = '';
    
    while (String(documentStatus) !== 'error' && String(documentStatus) !== 'done') {
      const { data: statusDocument} = await useGetScheduleReportStatusRequest();
      documentStatus = statusDocument.ret_value?.statusReport;

      if(documentStatus === 'error'){
        console.log('Error on generate Schedule Report: ', statusDocument.ret_value?.errorMessage);
        throw new Error('Failed to generate your premium schedule, please try again');
      }

    };

  }

  function checkMandatoryPremiumCalculation() {
    const includeScheduleReportQst = questionnaire.find((qst) => qst.idQuestion === 1870);
    return (includeScheduleReportQst?.answer || '').toUpperCase() === 'YES';
  }

  useEffect(() => {
    if (
      useSaveQuestionnaireAnswerStatus === 200 &&
      useUpdateOperationsStatus === 200
    ) {

      if (checkMandatoryPremiumCalculation()) {
        generateScheduleReport().then((response) => {
          setGenerateSignatureEndorsementsLoading(true);
  
          generateSignatureEndorsements()
        }).catch((error) => {
            console.error('fitPostDocument - Error:', error);
            mc.error('Failed to generate your premium schedule, please try again');
            throw new Error('Failed to generate your premium schedule, please try again');
        });
      } else {
        setGenerateSignatureEndorsementsLoading(true);

        generateSignatureEndorsements();
      }
    } else if (useSaveQuestionnaireAnswerStatus === 400) {
      useSaveQuestionnaireAnswerError.errors?.map(error => {
        if (error.message) mc.error(error.message)
      })
    } else if (useUpdateOperationsStatus === 400) {
      useUpdateOperationsError.errors?.map(error => {
        if (error.message) mc.error(error.message)
      })
    }
  }, [useSaveQuestionnaireAnswerStatus, useUpdateOperationsStatus]);

  const handleQuestionnaire = (data) => {
    let questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc,
    ];

    const filteredQuestions = questionnaire.filter(qst =>
      qst.idQuestion === 1820
      || qst.idQuestion === 1867
      || qst.idQuestion === 1870
      || qst.idQuestion === 1871
      || qst.idQuestion === 1977
    );

    for (const question of filteredQuestions) {
      if (question.idQuestion === 1820) {
        question.key = 'endorsementReference_1820';
        if (!question?.answer && operationMetadata?.endorsementReference) {
          question.answer = operationMetadata?.endorsementReference;
        }
      }
      if (question.idQuestion === 1867) {
        question.answerOptions.forEach((option) => {
          if (option.idAnswerOption === 7524) {
            option.behaviorObject = {
              isResultDomainDocument: true,
              resultIdDomainDocument: idDomainDocument,
              resultIdDomainStatusDocument: idDomainStatusDocument
            }
          }
        })
      }
    }
    setQuestionnaire(filteredQuestions);
  }

  useEffect(() => {
    if (
      useHeaderNbiLoading ||
      useGetDocumentsEndorsementContractsLoading ||
      useEndorsementPackRiskMarketChangesLastQuestionnaireMrcLoading ||
      useEndorsementPackRiskMarketChangesListPreviewDocumentsLoading ||
      useOperationInfoLoading ||
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useUpdateOperationsLoading ||
      generateSignatureEndorsementsLoading ||
      useScheduleReportLoading ||
      useGetScheduleReportStatusLoading
    ) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [
    useHeaderNbiLoading,
    useGetDocumentsEndorsementContractsLoading,
    useEndorsementPackRiskMarketChangesLastQuestionnaireMrcLoading,
    useEndorsementPackRiskMarketChangesListPreviewDocumentsLoading,
    useOperationInfoLoading,
    useGetQuestionnairesAnswersLoading,
    useSaveQuestionnaireAnswerLoading,
    useUpdateOperationsLoading,
    generateSignatureEndorsementsLoading,
    useScheduleReportLoading,
    useGetScheduleReportStatusLoading
  ]);


  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        nmObligor: data.ret_value.nmObligor,
        projectName: data.ret_value.projectName,
        idOperation: props.match.params.idOperation,
      });
      setHistorymsg(data.ret_value.historical);
      setEndorsmentType(data.ret_value.endorsmentType);

    })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function getLastIdQuestionnaireMRC() {
    useEndorsementPackRiskMarketChangesLastQuestionnaireMrcRequest().then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      setLastIdQuestionnaire(data?.ret_value.lastOperationQuestionnaireId);
      setInsurersToGenerateMrc(data?.ret_value.idInsurers || []);
      setWillGenerateMrcDocument(data?.ret_value.willGenerateMRCDocument)
    }).catch((error) => {
      mc.error("Erro executando consulta\n" + error);
      console.error('fitPostReject - Error:', error);
    })
  }

  async function getOperationInfo() {
    useOperationInfoRequest().then(({ data: response }) => {
      useGetQuestionnairesAnswersRequest();
      setOperationMetadata(response.metadata);
      setIdProduct(response.idProduct);
      setIdDomainDocument(response.idDomainDocument);
      setIdDomainStatusDocument(response.idDomainStatusDocument);

      let documentDomain = null;
      let documentDomainStatus = null;
      if (response.idDomain === 398) {
        documentDomain = 399;
        documentDomainStatus = 118;
      } else if (response.idDomain === 400) {
        documentDomain = 401;
        documentDomainStatus = 143;
      } else if (response.idDomain === 254) {
        documentDomain = 450;
        documentDomainStatus = 180;
      } else if (response.isMarketChanges || response.idDomain === 410) {
        documentDomain = 453;
        documentDomainStatus = 205;
      } else if (response.idDomain === 395) {
        documentDomain = 397;
        documentDomainStatus = 100;
      } else if (response.idDomain === 253) {
        documentDomain = 493;
        documentDomainStatus = 270;
      }
      setIdDomainDocument(documentDomain);
      setIdDomainStatusDocument(documentDomainStatus);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getOperationInfo.name}\n` + error);
      });
  }

  const handleSaveQuestionnaireAnswer = (onlyQuestions) => {
    const body = { questionnaireAnswers: _.cloneDeep(questionnaire) };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map(group => {
          if (group?.length) {
            const rootQuestion = group.find(question => !question.idQuestionRoot);
            const childrenQuestions = group.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions
            if (!onlyQuestions) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...group];
            }
          }
        })
      }
    }

    for (const question of body.questionnaireAnswers) {
      if (
        (
          question.idDomainQuestion === 270 ||
          question.idDomainQuestion === 271 ||
          (question.idDomainQuestion === 44 && typeof question.answer === 'object')
        ) && question.answer
      ) {
        if (!(question.idQuestion === 1977 && typeof question.answer === 'string')) {
          try {
            question.answer = JSON.stringify(question.answer)
          } catch (e) {
          }
        }
      } else if (question.idQuestion === 1820 && question.answer) {
        question.answer = question.answer.padStart(3, '0');
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }

  const buildValidation = () => {
    const validationSchema = {};

    const questionnaire = handleSaveQuestionnaireAnswer(true);

    for (const question of questionnaire) {
      if (!question.key) continue;
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().test("answer-validation", "Campo obrigatório", function (value) {
          return question.answer === 0 ? true : !!question.answer;
        }) : yup.string().notRequired();
    }

    return yup.object().shape(validationSchema);
  }

  const validateEndorsementContract = () => {
    const endorsementContractQst = questionnaire.find((question) => question.idQuestion === 1867);
    const { answer } = endorsementContractQst;
    if (answer.length) {
      if (!answer.some((file) => file.documentType.idAnswerOption === '7524')) throw new Error('Please, add the endorsement contract')
    }
  }

  const handleSubmit = (values) => {
    const premiumCalculationQst = questionnaire.find((qst) => qst.idQuestion === 1977);
    const premiumCalculationAnswer = Array.isArray(premiumCalculationQst?.answer) ? premiumCalculationQst.answer : JSON.parse(premiumCalculationQst?.answer || '[]');
    if (!premiumCalculationAnswer.length && checkMandatoryPremiumCalculation()) {
      mc.error("To process endorsements, you must load a Premium Calculations file.");
      return;
    }

    buildValidation()
      .validate(values, { abortEarly: false })
      .then(() => {
        validateEndorsementContract()
        handleSaveQuestionnaireAnswer()

        const endorsementRefAnswer = questionnaire.find(
          qst => qst.idQuestion === 1820
        )?.answer;

        useUpdateOperationsRequest({
          operationMetadata: {
            ...operationMetadata,
            endorsementReference: endorsementRefAnswer.padStart(3, '0')
          }
        })
      })
      .catch((e) => {
        if (e.message === 'Please, add the endorsement contract') {
          mc.error(e.message)
        } else {
          onValidationError(e, mc, formik, questionnaire, [])
        }

        loading.stop();
      })
  }

  async function handleSendApproval() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);

    let bodyMRC = {
      isMarketChanges: true,
      idLastMRCQuestionnaire: lastIdQuestionnaire,
      insurersToGenerateMrc,
      willGenerateMrcDocument
    }

    await fitinsur.saveMrcPart1(props.match.params.idOperation, bodyMRC)
      .then(resp => resp.json())
      .then(async response => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          loading.stop();
          return;
        }

        fitinsur.saveMrcPart2(props.match.params.idOperation, bodyMRC).then(resp => resp.json())
          // .then(response => {
          //
          //   if (response.ret_code != 200) {
          //     mc.error(response.ret_msg_details);
          //     loading.stop();
          //     return;
          //   }
          //
          //   handlePolicyPack();
          // })
          // .catch((error) => {
          //   mc.error("There was an error while saving your data (MRC2): \n" + error);
          //   loading.stop();
          // });


        setTimeout(() => {
          getStatusOperation()
        }, 3000);
      })
      .catch((error) => {
        mc.error("There was an error while saving your data (MRC1): \n" + error);
        loading.stop();
      });

    if (idProduct === 16) {
      await fitinsur.requestGenerateWording(props.match.params.idOperation)
        .then(data => data.json())
        .then(resp => {
          if (resp.ret_code !== 200) {
            mc.error(resp.ret_msg_details);
            return;
          }
        }).catch(error => {
          mc.error("Erro executando consulta\n" + error);
          console.error('fitPostReject - Error:', error);
        });
    }
  }


  function getStatusOperation() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGenerateMrcStatus(props.match.params.idOperation)
        .then(response => response.json())
        .then(data => {
          if (data.ret_code !== 200) {
            mc.error(data.ret_msg_details || 'There was an error while processing your data, please try again');
             loading.stop();
            return;
          }

          if (data.ret_value.errorMessage && data.ret_value.errorMessage.trim().length) {
            mc.error(data.ret_value.errorMessage || 'There was an error while processing your data, please try again')
             loading.stop();
            return
          }

          if (data.ret_value.statusOperation === 'created') {
            handlePolicyPack();
            return;
          };

          setTimeout(() => {
            getStatusOperation();
          }, 3000);

        }).catch((error) => {
       loading.stop();
      mc.error("There was an error while fetching your data:  \n" + error);
      console.error('fitPostListContact - Error:', error);
    });
  }


  function handlePolicyPack() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.createPolicyPack(props.match.params.idOperation, idDocumentsToSave)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        history.push(`/broking/send-approval-pack/${props.match.params.idOperation}`);
        loading.stop();
      })
      .catch((error) => {
        mc.error(error);
        console.error('fitPostReject - Error:', error);
      });
  }


  function handleGetFiles() {
    useGetDocumentsEndorsementContractsRequest().then(({ data: response }) => {
      if (response.ret_code !== 200) {
        mc.error(response.ret_msg_details);
        return;
      }
      const files = response.ret_value;
      let aux = [];

      files.forEach(file => {
        let obj = {
          dsTypeDocument: "Attachment",
          nameDocument: file.nameDocument,
          idTypeDocument: file.idTypeDocument,
          nameFile: file.nameFile,
          size: file.size,
          type: file.type,
          urlLink: file.urlLink,
          idDocument: file.idDocument
        };
        aux.push(obj);
      });
      setAttachments(aux);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  }

  async function generateSignatureEndorsements(showInsuredStamps) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    let body = {
      idPreviewDocumentsToSend: idDocumentsToSave,
      insurersToGenerateMrc,
      willGenerateMrcDocument,
      showInsuredStamps: showInsuredStamps == true || showInsuredStamps == false ? showInsuredStamps : formik?.current?.values?.showInsuredStamps,
    };

    fitinsur.generateSignatureEndorsements(props.match.params.idOperation, body)
      .then(data => data.json())
      .then(response => {
        handleSendApproval()
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${generateSignatureEndorsements.name}\n` + error);
      });
  }

  function handleRmvAttach(index) {
    loading.start();
    setAttachments(attachments.filter(tag => attachments.indexOf(tag) !== index));

    const idDocument = attachments[index].idDocument

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestDeleteSchedulleAssumptionsCorrections(props.match.params.idOperation, idDocument)
      .then(data => data.json())
      .then(resp => {
        loading.stop();

        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          return;
        } else {
          handleGetFiles();
        }
      }).catch(err => {
        mc.error("An error happened, please try again");
        loading.stop();
      });
  };

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleDocument() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetDocumentMetadata(props.match.params.idOperation)
      .then(response => response.json())
      .then(response => {
        setInitialContractChanges(response.contractChanges);
      })
      .catch((error) => {
        mc.error("Error\n" + error);
      });
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    if (isClient === true) {
      history.push('/list');
      return;
    }

    handleSummary();
    handleGetFiles();
    handleDocument();
    getLastIdQuestionnaireMRC();
    getListPreviewDocuments();
    getOperationInfo();
  }, [])


  function getListPreviewDocuments() {
    useEndorsementPackRiskMarketChangesListPreviewDocumentsRequest().then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }

      setListPreviewDocuments(data?.ret_value);
    }).catch((error) => {
      mc.error("Erro executando consulta\n" + error);
      console.error('fitPostReject - Error:', error);
    })
  }

  function handleSelect(e, ids = []) {
    if (ids.length >= 1) {
      setSelectedItems([...selectedItems, ...ids]);
      return
    }

    const alreadySelected = selectedItems.findIndex((item) => item === e);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item !== e);
      setSelectedItems(filteredItems);
      setIdDocumentsToSave(filteredItems)
    } else {
      if (e) {
        setSelectedItems([...selectedItems, e]);
        setIdDocumentsToSave([...selectedItems, e])
      }
    };
  };

  // useEffect(() => {
  //   if(insurersToGenerateMrc && insurersToGenerateMrc.length > 0) {
  //     for (const listPreview of listPreviewDocuments) {
  //       if (listPreview.idDomain === 324 || (listPreview.documentType == 'Wording' || listPreview.documentType == 'Declaration')) {
  //         setSelectedItems(oldSelectItems => [...oldSelectItems, listPreview.idDocument]);
  //         setIdDocumentsToSave(oldIds => [...oldIds, listPreview.idDocument]);
  //       }
  //     }
  //   }
  // }, [listPreviewDocuments]);

  function renderPreviewDocuments() {
    if (listPreviewDocuments && listPreviewDocuments.length) {
      return (
        <Row>
          <Col md={12} style={{ marginTop: "15px" }}>
            <Label>Additional documents to be signed by new insurers only</Label>
            {listPreviewDocuments && listPreviewDocuments.map(doc => (
              <RowDocuments>
                <Col md={4}>
                  <Label>{doc?.referenceNumber}</Label>
                </Col>
                <Col md={4}>
                  <Label>{doc?.documentType}</Label>
                </Col>
                <Col md={4}>
                  <RowIcon>
                    <Icon
                      name="search"
                      onClick={() => window.open(doc?.urlDocument, '_blank')} />

                    <div>
                      <label>
                        <CheckBox
                          onChange={() => { handleSelect(doc.idDocument) }}
                          checked={selectedItems.includes(doc.idDocument) ? true : false}
                        />
                      </label>
                    </div>
                  </RowIcon>
                </Col>
              </RowDocuments>
            ))}
          </Col>
        </Row>
      )
    }
  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />

      <ContentCard
        icon
        title={'ENDORSEMENT RISK & MARKET CHANGES - EDIT ENDORSEMENT CONTRACT'}
        info={{ idOperation: props.match?.params?.idOperation || null }}
      >
        <Formik
          innerRef={formik}
          initialValues={{
            endorsementMessage: '',
          }}
          onSubmit={(values) => handleSubmit(values)}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          validationSchema={validationSchema}
        >
          {({ touched, values, setFieldValue, setFieldError, errors }) => {
            return (
              <Form>
                <FormSection
                  sectionName="ENDORSEMENT_EDIT"
                  setQuestionnaire={setQuestionnaire}
                  values={values}
                  questionnaire={questionnaire}
                  setFieldValue={setFieldValue}
                  formikRef={formik}
                  idOperation={props.match?.params?.idOperation}
                  errors={errors}
                  setFieldError={setFieldError}
                  ignoreModality={true}
                  contextOfApp={authContext}
                />

                <PremiumCalculationSection
                  formikRef={formik}
                  questionnaire={questionnaire}
                  setQuestionnaire={setQuestionnaire}
                  values={values}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  setFieldError={setFieldError}
                  idOperation={props.match.params.idOperation}
                  idOperationParent={props.match.params.idOperationParent}
                  path={props?.path}
                  permissions={props.routePermissions}
                  useGetQuestionnaireAnswerRequest={useGetQuestionnairesAnswersRequest}
                  useSaveQuestionnaireAnswerRequest={useSaveQuestionnaireAnswerRequest}
                  questionsIdsToSave={[1820, 1867, 1870, 1871, 1977]}
                  onRemove={() => true}
                />

                {insurersToGenerateMrc && insurersToGenerateMrc.length > 0 && (renderPreviewDocuments())}

                <ButtonContainer>
                  <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                  <ButtonContent>
                    {!isApproved && (
                      <>
                        <div style={{ marginTop: "5px" }} >
                          <LostCancelButton idOperation={props.match?.params?.idOperation} />
                        </div>
                        <Button
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          primary
                          type="submit"
                          id="btnSubmit"
                        >
                          GENERATE PACK
                        </Button>
                      </>
                    )}
                  </ButtonContent>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
